uic-table-column {
    display: none;
}
